import { Entity, EntityTypeLabel } from "@/model";


export const getEntityType = (entity: Entity): EntityTypeLabel => {
    if (entity.post_processing) {
        return "post";
    }
    if (entity.ignored) {
        return "ignore";
    }
    return "normal";
};

export const getEntityTypeChipClassName = (entityType: EntityTypeLabel) => {
    if (entityType === "normal") {
        return "badge-primary";
    }
    if (entityType === "post") {
        return "badge-info";
    }
    return "badge-danger";
};
